<template>
  <span
    class="logo-flag display-inline-block"
    :style="`--logo-color: ${logoColor}; --logo-hover-color: ${logoHoverColor}`"
  >
    <font-awesome-icon
      :icon="$v7.custom.faFontAwesomeLogo"
      :size="logoSize"
    />

    <span class="sr-only">{{ label }}</span>
  </span>
</template>

<script>
  export default {
    name: 'LogoFlag',

    props: {
      label: {
        type: String,
        default: 'Font Awesome'
      },
      logoColor: {
        type: String,
        default: 'var(--fa-brand-blue)'
      },
      logoHoverColor: {
        type: String,
        default: 'var(--fa-dk-yellow)'
      },
      logoSize: {
        type: String,
        default: 'lg'
      }
    },

    computed: {}
  }
</script>
